'use client';

import { Flex, Heading, Text } from '@chakra-ui/react';
import { memo } from 'react';

type ComingSoonPageProps = {
  title: string;
  description: string;
  icon?: React.ReactNode;
};

const ComingSoonPage = ({ title, description, icon }: ComingSoonPageProps) => {
  return (
    <Flex direction="column" h="full" alignItems="center" justifyContent="center" gap={3} p={4}>
      {icon != null && (
        <Flex
          alignItems="center"
          justifyContent="center"
          boxSize="56px"
          borderRadius="full"
          bgColor="surface.hover"
          color="text.secondary"
        >
          {icon}
        </Flex>
      )}
      <Text color="selection.500" fontSize="xs" fontWeight="semibold" textTransform="uppercase">
        Coming soon
      </Text>
      <Heading size="lg">{title}</Heading>
      <Text color="text.secondary" fontSize="sm" maxW="420px" textAlign="center">
        {description}
      </Text>
    </Flex>
  );
};

export default memo(ComingSoonPage);
